import { ConfigurationsModel } from '@/core/domain/configurations/models/configurations.model';
import { createAction, props } from '@ngrx/store';

export const loadAction = createAction(
    '[Configuration] load',
    props<{ value: ConfigurationsModel }>(),
);
